import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-md font-semibold transition-all duration-200 cursor-pointer disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 ring-ring/10 dark:ring-ring/20 dark:outline-ring/40 outline-ring/50 focus-visible:ring-4 focus-visible:outline-1 aria-invalid:focus-visible:ring-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[var(--shadow-depth-md)] hover:bg-primary/90 hover:shadow-[var(--shadow-depth-lg)] active:translate-y-0",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[var(--shadow-depth-md)] hover:bg-destructive/90 hover:shadow-[var(--shadow-depth-lg)] active:translate-y-0",
        outline:
          "bg-bg-light shadow-[var(--shadow-depth-sm)] ring-1 ring-gray-300/40 text-black-1 hover:bg-white hover:shadow-[var(--shadow-depth-md)] active:translate-y-0",
        secondary:
          "bg-secondary text-secondary-foreground shadow-[var(--shadow-depth-md)] hover:bg-secondary/80 hover:shadow-[var(--shadow-depth-lg)] active:translate-y-0",
        ghost:
          "hover:bg-accent hover:text-accent-foreground active:bg-accent active:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline disabled:bg-transparent",
      },
      size: {
        lg: "w-full h-12 px-4 py-2.5 text-sm",
        default: "w-full h-10 px-4 py-2.5 text-sm",
        sm: "w-full h-9 px-1 py-2.5 text-xs",
        icon: "size-8 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
